// IOS-Q9 app-handoff interstitial (sketch signed off 2026-09-03).
//
// The emailed sign-in link can never auto-open the iOS app (it lands on
// the firebaseapp.com action domain and Apple ignores redirects for
// universal links), so /auth offers the hop instead: a custom-scheme URL
// carrying the full sign-in link, which the app's MagicLinkService
// unwraps (luckyclaww://auth?link=<encoded>). Works from Safari and
// in-app browsers (Gmail) alike.

// iPadOS 13+ masquerades as macOS - the MacIntel + touch check catches it.
export const isIOSDevice = (nav = navigator) =>
  /iPad|iPhone|iPod/.test(nav.userAgent) ||
  (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1);

// Must stay in lockstep with the app's MagicLinkPolicy.embeddedLink
// parser: scheme "luckyclaww", host "auth", percent-encoded "link" param.
export const appHandoffUrl = (href) =>
  `luckyclaww://auth?link=${encodeURIComponent(href)}`;
